import { render, staticRenderFns } from "./CustomMensagens.vue?vue&type=template&id=1470ba48&"
import script from "./CustomMensagens.vue?vue&type=script&lang=js&"
export * from "./CustomMensagens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports